<div class="h-100 d-flex flex-column">
  <div class="tabBar gap-4 ">
    <div class="d-flex title-container">
      <span class="create-offer-title mb-3">{{'offer.createOffer.title'|translate}}</span>
    </div>
    <div class="d-flex justify-content-between">
      <button (click)="scroll(0) " [id]="idSections[0]+'button'"
              class="detail-page-tab-button" [ngClass]="{'selected': scrolled === 0}">
        {{'offer.createOffer.buttons.coverage' | translate}}
      </button>
      <button (click)="scroll(1)" [id]="idSections[1]+'button'"
              class="detail-page-tab-button" [ngClass]="{'selected': scrolled === 1}">
        {{'offer.createOffer.buttons.premium' | translate}}
      </button>
      <button (click)="scroll(2) " [id]="idSections[2]+'button'"
              class="detail-page-tab-button" [ngClass]="{'selected': scrolled === 2}">
        {{'offer.createOffer.buttons.clauses' | translate}}
      </button>
      <button (click)="scroll(3) " [id]="idSections[3]+'button'"
              class="detail-page-tab-button" [ngClass]="{'selected': scrolled === 3}">
        {{'offer.createOffer.buttons.creator' | translate}}
      </button>

    </div>
  <hr />
  </div>


  <ng-scrollbar visibility="hover" (scroll)="onScrollY($event)">

    <div id="right" class="inner-content-container">
      <app-coverage-information [id]="idSections[0]" [maxCoverage]="maxCoverage"></app-coverage-information>
      <hr>
      <app-premium-information-form [id]="idSections[1]"></app-premium-information-form>
      <hr>
      <app-individual-information-form [id]="idSections[2]" (uploadInProgress)="receiveUploadStatus($event)"></app-individual-information-form>
      <hr>
      <app-your-data [id]="idSections[3]"></app-your-data>


    </div>
    <div class="d-flex justify-content-center align-items-center button-container">
      <button class="tile-button cursor-pointer blue-content mt-5"
              [disabled]="!(allFormsValid$ |async) || uploadInProgress"
              (click)="navigateToPreview(basedOnOfferId)">
        <span class="cursor-pointer">
          {{'offer.createOffer.showPreview'|translate}}
        </span>
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>

  </ng-scrollbar>

</div>
